import React, { Component } from 'react';
import SweetAlert from 'sweetalert2-react';
function ModalErrorDisconnect(props) {
    return (
        <SweetAlert
            show={props.ShowModalErroDc}
            title="Apakah Komputer Anda Terkoneksi Dengan Internet?"
            text="Kami tidak dapat terhubung ke server kami"
            type="question"
            showCancelButton
            onConfirm={() => props.setShowModalErroDc()}
        />
    )
}
export default ModalErrorDisconnect;